import { paths } from "config/paths";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { toast, MapsPortalMediumView as View } from "ui-components";
import { useIsCreateMapAllowed } from "~maps-portal/hooks/use-is-create-map-allowed";
import { useCreateMap } from "~maps-portal/queries/useCreateMap";
import { useGetCurrentMaps } from "~maps-portal/queries/useGetMaps";
import { useView } from "~maps-portal/states/filters";
import { Map } from "~maps-portal/types/__generated/gql/graphql";

const Component = () => {
	const router = useWebRouter();
	const isCreateMapAllowed = useIsCreateMapAllowed();
	const createMap = useCreateMap();
	const { data: maps = [], isLoading } = useGetCurrentMaps();

	const accountName = router._query.accountName!;

	const handleCreateMap = () => {
		toast.promise(
			async () => {
				try {
					const response = await createMap.mutateAsync({
						input: {
							name: "Untitled Map",
						},
					});
					const path = paths.accountName.maps.mapId.mapName.root(
						accountName,
						response.id,
						response.name,
					);
					void router.push(path);
				} catch (error) {
					console.error("Error creating map:", error);
				}
			},
			{
				loading: "Processing your request...",
				success: "Success! Taking you to map...",
				error: (e) => e.message ?? "Something went wrong!",
			},
		);
	};

	return (
		<View
			isLoading={isLoading}
			items={maps as Map[]}
			onItemLock={console.log}
			onCreateMap={handleCreateMap}
			isCreateMapAllowed={isCreateMapAllowed}
			isDeleteMapAllowed={isCreateMapAllowed}
		/>
	);
};

export const MediumView = () => {
	const view = useView();

	return view === "medium" ? <Component /> : null;
};
